import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class MaintenanceSummaryService
{
    private readonly refreshRequestedSubject = new Subject<void>();
    public readonly refreshRequested$ = this.refreshRequestedSubject.asObservable();

    public refresh(): void
    {
        this.refreshRequestedSubject.next();
    }
}
